import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Container = styled.article`
    display: flex;
    flex-direction: column;
    padding-top: 64px;
    padding-bottom: 68px;
    gap: 64px;
`;

export const StepContainer = styled.section`
    display: flex;
    flex-direction: column;
    gap: 28px;
`;

export const Title = styled.div`
    color: ${COLORS.white};
    ${FONTS.H2};
    
    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H3};
    }

    @media (max-width: ${wideBreakpoints.sMobile}) {
        margin-bottom: 16px;
    }
`;
